import React from "react";
import Context from "../../../../../Context";
import Blocker from "../../../../Misc/Blocker";

export default class UserDetailAreas extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      items: {},
      areas: [],
      itemsOrdered: {},
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    if (!this.props.user["id"]) return;
    this.setState({ pending: true });

    let items = {};
    let result = await this.context.api.q("/admin/area/list");

    if (result !== false) {
      if (result["id"]) result = [result];
      if (Array.isArray(result)) {
        result.forEach((item) => {
          if (item.code === "root") item.name = "Все подразделения";
          items[item.id] = item;
        });
      }
    }

    let areas = [];
    result = await this.context.api.q("/admin/member/area", {
      id: this.props.user["id"],
    });
    if (result !== false) {
      if (result["id"]) result = [result];
      if (Array.isArray(result)) {
        result.forEach((item) => {
          areas.push(String(item.id));
        });
      }
    }

    let itemsOrdered = {};

    Object.entries(items).forEach(([id, item]) => {
      if (item.level === 0) {
        itemsOrdered = Object.assign(
          itemsOrdered,
          this.getChildren(items, id, 0)
        );
      }
    });
    this.setState({ items, areas, itemsOrdered, pending: false });
  };

  getChildren = (items, seekId, level) => {
    let children = {};
    Object.entries(items).forEach(([id, item]) => {
      if (String(item.parent) === seekId) {
        children[id] = { ...item, level };
        children = Object.assign(
          children,
          this.getChildren(items, id, level + 1)
        );
      }
    });
    return children;
  };

  check = async (id, checked) => {
    if (!this.props.user["id"]) return;
    this.setState({ pending: true });

    let result = false;

    if (checked) {
      result = await this.context.api.q("/admin/member/area/add", {
        area: id,
        id: this.props.user["id"],
      });
    } else {
      result = await this.context.api.q("/admin/member/area/delete", {
        area: id,
        id: this.props.user["id"],
      });
    }
    if (result !== false) {
      this.context.toast("Подразделение переключено", "success");
      this.load();
    } else {
      this.context.toast("Не удалось переключить подразделение", "error");
      this.setState({ pending: false });
    }
  };

  save = async (data) => {
    data.id = this.props.user["id"];
    this.props.onPending(true);
    let result = await this.context.api.q("/admin/user/set", data);
    if (result !== false) {
      this.context.toast("Профиль пользователя сохранен", "success");
      this.props.onFinish();
    } else {
      this.context.toast("Не удалось сохранить профиль прользователя", "error");
      this.props.onPending(false);
    }
  };

  render() {
    return (
      <>
        <div>
          <Blocker on={this.state.pending}>
            <div className="px-lg-5">
              {Object.entries(this.state.itemsOrdered).map(([id, item]) => (
                <label
                  key={id}
                  className={`checkbox my-4 ml-${5 * item.level}`}
                >
                  <input
                    id={id}
                    onChange={(e) => this.check(e.target.id, e.target.checked)}
                    checked={this.state.areas.includes(id)}
                    type="checkbox"
                    key={id}
                  />
                  <span className="mr-4"></span>
                  {item.name}
                </label>
              ))}
            </div>
          </Blocker>
        </div>
      </>
    );
  }
}
